/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiSocietaSocietaidSmtpConfigurationMutationRequest,
  PutApiSocietaSocietaidSmtpConfigurationMutationResponse,
  PutApiSocietaSocietaidSmtpConfigurationPathParams,
} from '../models/PutApiSocietaSocietaidSmtpConfiguration.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiSocietaSocietaidSmtpConfigurationMutationResponseSchema,
  putApiSocietaSocietaidSmtpConfigurationMutationRequestSchema,
} from '../zod/putApiSocietaSocietaidSmtpConfigurationSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiSocietaSocietaidSmtpConfigurationMutationKey = () =>
  [{ url: '/api/societa/:societaId/smtp-configuration' }] as const;

export type PutApiSocietaSocietaidSmtpConfigurationMutationKey = ReturnType<
  typeof putApiSocietaSocietaidSmtpConfigurationMutationKey
>;

/**
 * {@link /api/societa/:societaId/smtp-configuration}
 */
export async function putApiSocietaSocietaidSmtpConfiguration(
  societaId: PutApiSocietaSocietaidSmtpConfigurationPathParams['societaId'],
  data: PutApiSocietaSocietaidSmtpConfigurationMutationRequest,
  config: Partial<
    RequestConfig<PutApiSocietaSocietaidSmtpConfigurationMutationRequest>
  > & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData =
    putApiSocietaSocietaidSmtpConfigurationMutationRequestSchema.parse(data);
  const res = await request<
    PutApiSocietaSocietaidSmtpConfigurationMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiSocietaSocietaidSmtpConfigurationMutationRequest
  >({
    method: 'PUT',
    url: `/api/societa/${societaId}/smtp-configuration`,
    data: requestData,
    ...requestConfig,
  });
  return putApiSocietaSocietaidSmtpConfigurationMutationResponseSchema.parse(
    res.data,
  );
}

/**
 * {@link /api/societa/:societaId/smtp-configuration}
 */
export function usePutApiSocietaSocietaidSmtpConfiguration<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiSocietaSocietaidSmtpConfigurationMutationResponse,
      ResponseErrorConfig<Error>,
      {
        societaId: PutApiSocietaSocietaidSmtpConfigurationPathParams['societaId'];
        data: PutApiSocietaSocietaidSmtpConfigurationMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiSocietaSocietaidSmtpConfigurationMutationRequest>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiSocietaSocietaidSmtpConfigurationMutationKey();

  return useMutation<
    PutApiSocietaSocietaidSmtpConfigurationMutationResponse,
    ResponseErrorConfig<Error>,
    {
      societaId: PutApiSocietaSocietaidSmtpConfigurationPathParams['societaId'];
      data: PutApiSocietaSocietaidSmtpConfigurationMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ societaId, data }) => {
        return putApiSocietaSocietaidSmtpConfiguration(societaId, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
